import { CopyParagraph } from '@sleepstation/components-copy'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_SPACING } from '@sleepstation/const'
import { padding } from '@sleepstation/style-api-helpers'
import { outset } from '@sleepstation/style-mixins'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import QuestionList from './QuestionList'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({ spacing: LAYOUT_SPACING.LARGE })`
  ${outset()}
  ${padding([
    [1, 1.5, 2.5],
    [1.5, 1.5, 2],
  ])}
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const SelfReflection = ({ selfReflection }) => {
  const { intro, questions } = selfReflection

  return (
    <Layout>
      <CopyParagraph>{intro}</CopyParagraph>
      <QuestionList questions={questions} />
    </Layout>
  )
}

SelfReflection.propTypes = {
  selfReflection: PropTypes.object.isRequired,
}

SelfReflection.defaultProps = {}

export default SelfReflection
